





































import {Component, Vue} from 'vue-property-decorator';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import SideMenu from '@/components/SideMenu.vue';
import {VApp, VCard, VCardActions, VContent, VFooter} from 'vuetify/lib';

@Component({
	components: {
		Footer,
		Header,
		SideMenu,
		VApp,
		VCard,
		VCardActions,
		VContent,
		VFooter,
	},
})
export default class App extends Vue {
	private drawer = false;

	private sideIconClick() {
		this.drawer = true;
	}

	private backClick() {
		this.drawer = false;
	}
}
